var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table-column',{attrs:{"fixed":"","index":_vm.callbackIndex,"type":"index","width":"50","label":"行号"}})}
var staticRenderFns = []

export { render, staticRenderFns }